import { useCreateCtx } from '@cleartax/wg-library-hooks';
import { IParentProps } from '../utils/types';
export interface ICommentContext {
  parentComment: IParentProps;
  setParentComment: (value: IParentProps) => void;
  postId: number;
  loggedInLink: string;
  setCurrentUserName: (value: string | null) => void;
  currentUserName: string | null;
}
export const [useCommunityQACtx, CommunityQAProvider] =
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useCreateCtx<ICommentContext>();
